<main role="main">
  <router-outlet *ngIf="!loading; else loader"></router-outlet>
  <ng-template #loader>
    <app-loader></app-loader>
  </ng-template>
</main>
<div class="comment-backdrop" *ngIf="sharedService.globalComments.showComments"></div>
<div class="comments-section" *ngIf="sharedService.globalComments.showComments">
    <div class="comments-container" #commentsPopup>
        <app-shared-comments [moduleId]="sharedService.globalComments.moduleId" [module]="sharedService.globalComments.module"
            (onClose)="onCommentsClose($event)"></app-shared-comments>
    </div>
</div>
